import { SaveOutlined } from '@ant-design/icons';
import { useMutation, useQuery } from '@apollo/client/react';
import { App, Button, Col, Form, Input, Row } from 'antd';
import { useForm } from 'antd/es/form/Form';
import type React from 'react';
import { useEffect } from 'react';
import { LazyAiExamplesEditor } from '../../admin/ai/LazyAiExamplesEditor.tsx';
import { LAB_AI_SETTINGS_QUERY, UPDATE_LAB_AI_SETTINGS_MUTATION } from './LabAdminAiSettings.gql';

interface LabAdminAiSettingsProps {
  labId: string;
}

interface FormValues {
  aiSystemPromptExtension: string;
}

export const LabAdminAiSettings: React.FC<LabAdminAiSettingsProps> = ({ labId }) => {
  const [form] = useForm<FormValues>();
  const { message } = App.useApp();
  const [updateMutation, { loading: updateLoading }] = useMutation(UPDATE_LAB_AI_SETTINGS_MUTATION);

  const { data } = useQuery(LAB_AI_SETTINGS_QUERY, { variables: { id: labId } });

  useEffect(() => {
    form.setFieldsValue({
      aiSystemPromptExtension: data?.lab?.aiSystemPromptExtension ?? '',
    });
  }, [form, data]);

  const save = async (values: FormValues) => {
    try {
      await updateMutation({
        variables: {
          id: labId,
          input: { aiSystemPromptExtension: values.aiSystemPromptExtension || null },
        },
      });
      message.success('KI-Konfiguration wurde aktualisiert');
    } catch {
      message.error('KI-Konfiguration konnte nicht aktualisiert werden');
    }
  };

  return (
    <div style={{ padding: 24 }}>
      <Row gutter={[24, 0]}>
        <Col span={12}>
          <Form layout="vertical" form={form} onFinish={save}>
            <Form.Item
              name="aiSystemPromptExtension"
              label="System-Prompt Erweiterung"
              tooltip="Laborspezifischer Kontext für den KI-Assistenten, z.B. Spezialisierungen oder besondere Angebote. Wird zusätzlich zum globalen System-Prompt verwendet."
            >
              <Input.TextArea rows={8} />
            </Form.Item>
            <Button htmlType="submit" type="primary" disabled={updateLoading} icon={<SaveOutlined />}>
              Speichern
            </Button>
          </Form>
        </Col>
        <Col span={12}>
          <LazyAiExamplesEditor labId={labId} />
        </Col>
      </Row>
    </div>
  );
};
